import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import MunicipalidadHeader from '../components/Header/MunicipalidadHeader';
import Presidencia from '../components/Concejo/Presidencia';
import Bloque from '../components/Concejo/Bloque';
import { listHcdSitioWeb } from '@/api/municipalidadAPI';
import './ConcejoView.css';

const ConcejoView = () => {
  const [concejo, setConcejo] = useState(null);

  useEffect(() => {
    listHcdSitioWeb()
      .then((response) => {
        setConcejo(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return (
    <>
      <MunicipalidadHeader tipo="Gobierno" title="Concejo Deliberante"></MunicipalidadHeader>
      <Container className="content pagina-interna">
        {concejo != null && <Presidencia presidencia={concejo.presidencia}></Presidencia>}
        <h3>Bloques</h3>
        <Row>
          {concejo != null &&
            concejo.bloqueList !== null &&
            concejo.bloqueList.length > 0 &&
            concejo.bloqueList.map((item, idx) => (
              <Col lg="6" key={idx}>
                <Bloque item={item}></Bloque>
              </Col>
            ))}
        </Row>
      </Container>
    </>
  );
};

export default React.memo(ConcejoView);
